import { Link } from "react-router-dom";
import { Navbar } from "@/components/site/Navbar";
import { Footer } from "@/components/site/Footer";
import { Reveal } from "@/components/site/Reveal";
import { SITE_CONTACT, SOCIALS, MANAGEMENT_NAME } from "@/data/site";

// Own background — CSS-only gradient + nebula + grain (asset-free). Swap the
// fixed <div> for a <video>/<img> background using the same "fixed inset-0"
// pattern once a real asset is supplied. All contact routes through her
// management inbox (her form's booking contact) — her personal email is
// deliberately not published.
export default function Contact() {
  return (
    <div className="relative min-h-screen bg-[var(--sm-black)]">
      <div
        className="fixed inset-0 z-0 overflow-hidden"
        style={{ background: "radial-gradient(ellipse at 50% 30%, var(--sm-brown-deep), var(--sm-black) 70%)" }}
      >
        <div aria-hidden className="nebula opacity-50" />
        <div className="grain absolute inset-0" />
      </div>
      <Navbar />
      <main className="relative z-10 flex min-h-screen flex-col items-center justify-center px-6 text-center">
        <Reveal>
          <span className="overline">Contact</span>
          <h1 className="font-display mt-5 text-4xl text-[var(--sm-text)] sm:text-5xl">Get in Touch</h1>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="mt-10 flex flex-col items-center gap-3">
            <span className="font-accent text-xs uppercase tracking-[0.2em] text-white/50">Management &amp; Booking — {MANAGEMENT_NAME}</span>
            <a
              href={`mailto:${SITE_CONTACT.email}`}
              className="font-accent text-lg text-[var(--sm-gold-light)] transition-colors hover:text-white"
            >
              {SITE_CONTACT.email}
            </a>
            {SITE_CONTACT.phone && (
              <a
                href={`tel:${SITE_CONTACT.phone.replace(/[^\d+]/g, "")}`}
                className="font-body text-base text-white/70 transition-colors hover:text-white"
              >
                {SITE_CONTACT.phone}
              </a>
            )}
            <Link
              to="/epk"
              className="font-accent mt-2 text-xs uppercase tracking-[0.2em] text-white/50 underline decoration-white/20 underline-offset-4 transition-colors hover:text-[var(--sm-gold-light)]"
            >
              Booking? See the EPK
            </Link>
          </div>
        </Reveal>
        <Reveal delay={0.3}>
          <div className="mt-10 flex flex-wrap items-center justify-center gap-7">
            {SOCIALS.map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                className="font-accent text-xs uppercase tracking-[0.2em] text-white/55 transition-colors hover:text-[var(--sm-gold-light)]"
              >
                {s.label}
              </a>
            ))}
          </div>
        </Reveal>
      </main>
      <Footer />
    </div>
  );
}
